import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from "../classNames.js";
import { modifier, } from "../modifiers/index.js";
const tag = (h) => h === 1
    ? "h1"
    : h === 2
        ? "h2"
        : h === 3
            ? "h3"
            : h === 4
                ? "h4"
                : h === 5
                    ? "h5"
                    : h === 6
                        ? "h6"
                        : "p";
const _classNames = (type, { className, isSpaced, size }) => classNames(type, size ? `is-${size}` : undefined, modifier({ isSpaced }), className);
export const Title = ({ children, className, h, isSpaced, size, ...props }) => {
    const Tag = tag(h);
    const _class = _classNames("title", { className, isSpaced, size });
    return (_jsx(Tag, { className: _class, ...props, children: children }));
};
export const Subtitle = ({ children, className, h, isSpaced, size, ...props }) => {
    const Tag = tag(h);
    const _class = _classNames("subtitle", { className, isSpaced, size });
    return (_jsx(Tag, { className: _class, ...props, children: children }));
};
